import script from "./ArgonActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonActions.vue?vue&type=script&setup=true&lang=js"

import "./ArgonActions.vue?vue&type=style&index=0&id=e1f2235e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1f2235e"]])

export default __exports__